import React from 'react';
import Base from './Base';

export type CircleButtonVariant = 'error' | 'warning' | 'success';

type ButtonProps = React.ComponentProps<typeof Base> & {
    variant?: CircleButtonVariant;
};

const variantClass: Record<CircleButtonVariant, string> = {
    error: 'btn--outline-error',
    warning: 'btn--outline-warning',
    success: 'btn--outline-success',
};

const Circle: React.FC<ButtonProps> = ({
    className,
    variant = 'error',
    iconOnly = true,
    ...rest
}) => {
    const classes = ['btn--circle', variantClass[variant], className].filter(Boolean).join(' ');
    return <Base className={classes} iconOnly={iconOnly} {...rest} />;
};

export default Circle;
